import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import { theme } from '../../styles/theme';

interface ResetViewControlProps {
  position?: L.ControlPosition;
  center: [number, number];
  zoom: number;
  darkMode: boolean;
}

const ResetViewControl: React.FC<ResetViewControlProps> = ({
  position = 'topleft',
  center,
  zoom,
  darkMode,
}) => {
  const map = useMap();

  useEffect(() => {
    const ResetControl = L.Control.extend({
      onAdd: function() {
        const container = L.DomUtil.create('div', 'leaflet-bar leaflet-control');
        
        const button = L.DomUtil.create('a', '', container);
        button.innerHTML = 'Reset View';
        button.href = '#';
        button.title = 'Reset to default view';
        button.style.width = 'auto';
        button.style.padding = '5px 10px';
        button.style.fontSize = '12px';
        button.style.lineHeight = '20px';
        button.style.textAlign = 'center';
        button.style.textDecoration = 'none';
        button.style.color = darkMode ? theme.colors.text.darkPrimary : theme.colors.text.primary;
        button.style.backgroundColor = darkMode ? theme.colors.background.dark : '#fff';
        button.style.border = `1px solid ${darkMode ? theme.colors.border.dark : theme.colors.border.light}`;
        button.style.borderRadius = '4px';
        button.style.cursor = 'pointer';
        
        // Add hover effect
        button.onmouseover = function() {
          button.style.backgroundColor = darkMode ? theme.colors.background.darkPaper : '#f4f4f4';
        };
        
        button.onmouseout = function() {
          button.style.backgroundColor = darkMode ? theme.colors.background.dark : '#fff';
        };
        
        button.onclick = function(e) {
          e.preventDefault();
          e.stopPropagation();
          map.setView(center, zoom, {
            animate: true,
            duration: 0.75
          });
          return false;
        };
        
        // Prevent map interaction when clicking the button
        L.DomEvent.disableClickPropagation(container);
        L.DomEvent.disableScrollPropagation(container);
        
        return container;
      },
    });

    const control = new ResetControl({ position });
    control.addTo(map);

    // Cleanup
    return () => {
      control.remove();
    };
  }, [map, position, center, zoom, darkMode]);

  return null;
};

export default ResetViewControl;